module.exports = __webpack_public_path__ + "img/t_coin.ff63c0ff.png";